import React from "react";
import EventBooking from "../components/booking/EventBooking";
import WorkWithUs from "../components/sections/WorkWithUs";

export default function EventBookingPage() {
  return (
    <>
      <section className="transportTab_wrap section_pt section_pb">
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="transport_tabs">
                <div className="tab-content">
                  <EventBooking />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-12 d-md-block d-none">
              <div className="bookingForm_image">
                <img
                  src="/assets/img/all-images/booking-img.png"
                  alt="Booking"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <WorkWithUs />
    </>
  );
}
